export const timeoutSpan = 60 * 1000;
export const GlobalAppLoaderName = '__nabxAppLoader__';
export const EventNameRequestToken = 'request_token';
export const TokenExchangeEventMgrName = 'nabx-mini-app-loader';
export const TokenAttributeOnMiniApp = 'auth';
